var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41421 0.585786C2.63317 -0.195262 1.36683 -0.195262 0.585786 0.585786C-0.195262 1.36683 -0.195262 2.63317 0.585786 3.41421L3.41421 0.585786ZM13.5858 16.4142C14.3668 17.1953 15.6332 17.1953 16.4142 16.4142C17.1953 15.6332 17.1953 14.3668 16.4142 13.5858L13.5858 16.4142ZM0.585786 3.41421L13.5858 16.4142L16.4142 13.5858L3.41421 0.585786L0.585786 3.41421Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.585787 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142C1.36683 17.1953 2.63316 17.1953 3.41421 16.4142L0.585787 13.5858ZM16.4142 3.41421C17.1953 2.63317 17.1953 1.36684 16.4142 0.585787C15.6332 -0.195262 14.3668 -0.195262 13.5858 0.585786L16.4142 3.41421ZM3.41421 16.4142L16.4142 3.41421L13.5858 0.585786L0.585787 13.5858L3.41421 16.4142Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXis);
export default __webpack_public_path__ + "static/media/xis.c80948bc78f0b5db2a8903bd8c747d84.svg";
export { ForwardRef as ReactComponent };